import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { isNil } from "lodash";
import { LoadingDots } from "./LoadingDots";

export interface TimeButtonListProps {
  isLoading?: boolean;
  options: { label: string; value: string; disabled?: boolean }[];
  onChange: (value: string) => void;
  selected: string;
  className?: string;
  wrap?: boolean;
  overflowMarker?: (node?: Element | null | undefined) => void;
}

export const TimeButtonList = ({
  isLoading,
  options,
  selected,
  onChange,
  wrap,
  overflowMarker,
}: TimeButtonListProps) => {
  const theme = useTheme();

  if (isLoading) {
    return <LoadingDots />;
  }

  const defaultWrapClass = "flex flex-nowrap sm:flex-wrap";
  const adjustedWrapClass = wrap ? "flex-wrap" : "flex-nowrap";
  return (
    <div className="flex w-full overflow-hidden md:items-center">
      <div
        className={`flex gap-2 overflow-auto py-2 ${
          isNil(wrap) ? defaultWrapClass : adjustedWrapClass
        }`}
        data-cy="time-button-list"
        data-length={options.length}
      >
        {options.map(({ value, label, disabled = false }) => {
          const isSelected = selected === value;
          return (
            <IconButton
              classes={{
                root: `flex-1 min-w-[75px] max-w-[75px]`,
              }}
              color="primary"
              data-cy="timestamp-btn"
              data-value={value}
              disabled={disabled}
              key={`time-button-${label}`}
              onClick={() => {
                onChange(value);
              }}
              size="medium"
              style={{
                textWrap: "nowrap",
              }}
              sx={{
                backgroundColor: isSelected
                  ? theme.palette.primary.dark
                  : theme.palette.primary.light,
                color: theme.palette.primary.contrastText,
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                },
              }}
            >
              <Typography className="px-2" variant="text_md_sb">
                {label}
              </Typography>
            </IconButton>
          );
        })}
        {overflowMarker ? (
          <Box className="pointer-events-none h-1 w-1" ref={overflowMarker} />
        ) : null}
      </div>
    </div>
  );
};
